import { dataTestRoot } from "@/constants";
/**
 * @deprecated
 * @todo remove with https://avivgroup.atlassian.net/browse/ASC-3772
 */
export const useTestId = (key) => `${dataTestRoot}.${key}`;
